import { Button } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

export interface ViewResponsesButtonProps {
  href: string;
}

export function ViewResponsesButton(props: ViewResponsesButtonProps): JSX.Element {
  const { href } = props;
  const { t } = useTranslation('feedback');

  return (
    <Button as="a" kind="secondary" size="s" href={href}>
      {t('survey-list.table.view-responses')}
    </Button>
  );
}
